// Session management utilities
const SESSION_DURATION = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

export const sessionManager = {
  // Set session with expiration
  setSession: (authToken, userRole = '', phoneNumber = '') => {
    const sessionData = {
      authToken,
      userRole,
      phoneNumber,
      expiresAt: Date.now() + SESSION_DURATION,
      loginDate: Date.now()
    };
    
    localStorage.setItem('userSession', JSON.stringify(sessionData));
    
    // Keep sessionStorage for backward compatibility
    sessionStorage.setItem('authToken', authToken);
    if (userRole) sessionStorage.setItem('userRole', userRole);
    if (phoneNumber) sessionStorage.setItem('phoneNumber', phoneNumber);
  },

  // Get current session if valid
  getSession: () => {
    try {
      const sessionData = localStorage.getItem('userSession');
      if (!sessionData) return null;

      const session = JSON.parse(sessionData);
      
      // Check if session has expired
      if (Date.now() > session.expiresAt) {
        sessionManager.clearSession();
        return null;
      }

      return session;
    } catch (error) {
      console.error('Error reading session:', error);
      sessionManager.clearSession();
      return null;
    }
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const session = sessionManager.getSession();
    return session && session.authToken;
  },

  // Get user info from session
  getUserInfo: () => {
    const session = sessionManager.getSession();
    if (!session) return null;

    return {
      authToken: session.authToken,
      userRole: session.userRole,
      phoneNumber: session.phoneNumber,
      loginDate: new Date(session.loginDate),
      expiresAt: new Date(session.expiresAt)
    };
  },

  // Clear session
  clearSession: () => {
    localStorage.removeItem('userSession');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('userRole');
    sessionStorage.removeItem('phoneNumber');
    sessionStorage.removeItem('pendingUserRole');
  },

  // Update session (extend expiration)
  refreshSession: () => {
    const session = sessionManager.getSession();
    if (session) {
      session.expiresAt = Date.now() + SESSION_DURATION;
      localStorage.setItem('userSession', JSON.stringify(session));
    }
  }
};

export default sessionManager; 